import { render, staticRenderFns } from "./biochar-summary.vue?vue&type=template&id=51bbb642&scoped=true&"
import script from "./biochar-summary.vue?vue&type=script&lang=js&"
export * from "./biochar-summary.vue?vue&type=script&lang=js&"
import style0 from "./biochar-summary.vue?vue&type=style&index=0&id=51bbb642&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bbb642",
  null
  
)

export default component.exports